import { Button } from "@/components/ui/button";
import heroProfessional from "@/assets/hero-professional-small.webp";
import { useLanguage } from "@/contexts/LanguageContext";

const Hero = () => {
  const { t } = useLanguage();
  
  return (
    <section id="home" className="relative min-h-screen flex items-center bg-gradient-hero overflow-hidden">
      {/* Background geometric shapes */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-10 right-10 w-64 h-64 bg-accent/10 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-20 left-20 w-48 h-48 bg-secondary/15 rounded-full blur-2xl animate-float" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-1/2 right-1/4 w-32 h-32 bg-primary-light/20 rounded-full blur-xl animate-float" style={{animationDelay: '4s'}}></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-left">
            <p className="text-accent font-semibold text-sm mb-4 uppercase tracking-wide animate-fade-in">{t("hero.subtitle")}</p>
            
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" style={{ contentVisibility: 'auto' }}>
              {t("hero.title1")}<br />
              <span className="text-accent">{t("hero.title2")}</span>
            </h1>
            
            <p className="text-xl text-white/90 mb-8 max-w-lg leading-relaxed animate-fade-in" style={{animationDelay: '0.4s'}}>
              {t("hero.description")}
            </p>

            <Button 
              variant="secondary"
              size="lg" 
              className="text-lg px-8 py-4 bg-accent text-accent-foreground hover:bg-accent-dark transition-smooth shadow-glow animate-fade-in hover-scale whitespace-nowrap"
              style={{animationDelay: '0.6s'}}
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
            >
              {t("hero.cta")}
            </Button>
          </div>

          {/* Right Image */}
          <div className="relative animate-fade-in" style={{animationDelay: '0.8s'}}>
            <div className="relative">
              <img 
                src={heroProfessional} 
                alt="Ammattilainen kypärässä ja työkaluineen - ServiceMind24"
                className="w-full max-w-md ml-auto rounded-lg shadow-xl hover-scale"
                width="512"
                height="288"
                loading="eager"
              />
              <div className="absolute -top-4 -right-4 w-20 h-20 bg-accent/20 rounded-full blur-xl animate-pulse-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;